import {Component} from '@angular/core';
import {Block}     from "../../../block";

@Component({
    selector   : 'app-pricing-header-column',
    templateUrl: './pricing-header-column.component.html',
})
export class PricingHeaderColumnComponent extends Block {
}
